'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.module = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _immutable = require('immutable');

var _browser = require('invariant/browser');

var _browser2 = _interopRequireDefault(_browser);

var _dispatcher = require('../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _utils = require('flux/utils');

var _events = require('../events');

var _events2 = _interopRequireDefault(_events);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StageStore = function (_Store) {
  _inherits(StageStore, _Store);

  function StageStore(dispatcher) {
    _classCallCheck(this, StageStore);

    /*
     * The store data cache, indexed by feis id.
     *
     * feisid: {
     *   stages: Map({
     *     stageid: Map({
     *       name: '...',
     *       events: List([]),
     *     }),
     *   }),
     *
     *   unscheduled: List([]),
     * }
     */
    var _this = _possibleConstructorReturn(this, (StageStore.__proto__ || Object.getPrototypeOf(StageStore)).call(this, dispatcher));

    _this._data = (0, _immutable.Map)({});
    return _this;
  }

  _createClass(StageStore, [{
    key: '_seed',
    value: function _seed(fid, stages) {
      var stageMap = stages.reduce(function (map, stage) {
        map[stage.id] = stage;

        return map;
      }, {});

      this._data = this._data.setIn([fid, 'stages'], (0, _immutable.fromJS)(stageMap));
      this.__emitChange();
    }
  }, {
    key: '_add',
    value: function _add(fid, stage) {
      this._data = this._data.setIn([fid, 'stages', stage.id], (0, _immutable.fromJS)(stage));
      this.__emitChange();
    }
  }, {
    key: '_update',
    value: function _update(fid, stage) {
      this._data = this._data.setIn([fid, 'stages', stage.id], (0, _immutable.fromJS)(stage));
      this.__emitChange();
    }
  }, {
    key: '_updateSchedule',
    value: function _updateSchedule(fid, stage) {
      this._data = this._data.setIn([fid, 'stages', stage.id, 'events'], (0, _immutable.fromJS)(stage.events));
      this.__emitChange();
    }
  }, {
    key: '_remove',
    value: function _remove(fid, stage) {
      this._data = this._data.deleteIn([fid, 'stages', stage.id]);
      this.__emitChange();
    }
  }, {
    key: '_seedUnscheduled',
    value: function _seedUnscheduled(fid, events) {
      this._data = this._data.setIn([fid, 'unscheduled'], (0, _immutable.List)(events));
      this.__emitChange();
    }
  }, {
    key: 'getData',
    value: function getData(fid) {
      return fid ? this._data.get(fid) : this._data;
    }

    /**
     * This is the method that handles events from the Dispatcher. All mutations start here!
     */

  }, {
    key: '__onDispatch',
    value: function __onDispatch(_ref) {
      var actionType = _ref.actionType,
          payload = _ref.payload,
          context = _objectWithoutProperties(_ref, ['actionType', 'payload']);

      switch (actionType) {
        case _actions.CREATE_STAGE_SUCCESS:
          this._add(payload.fid, payload.stage);
          break;

        case _actions.REMOVE_STAGE_SUCCESS:
          this._remove(payload.fid, payload.stage);
          break;

        case _actions.UPDATE_STAGE_SUCCESS:
          this._update(payload.fid, payload.stage);
          break;

        case _actions.ATTACH_TO_STAGE_SUCCESS:
        case _actions.DETACH_FROM_STAGE_SUCCESS:
          this._updateSchedule(payload.fid, payload.stage);
          break;

        case _actions.SEED_STAGES_SUCCESS:
          this._seed(payload.fid, payload.stages);
          break;

        case _actions.LOAD_UNSCHEDULED_EVENTS_SUCCESS:
          this._seedUnscheduled(payload.fid, payload.events);
          break;

        case _actions.CREATE_SYLLABUS_SUCCESS:
          this._addToUnscheduled(payload.fid);
          break;

        case _actions.REMOVE_SYLLABUS_SUCCESS:
          break;

        // TODO: support seeding from local storage
      }
    }
  }]);

  return StageStore;
}(_utils.Store);

var _module = _angular2.default.module('ifeis.stages.store', []).service('stageStore', StageStore);

exports.module = _module;
exports.default = StageStore;


//////////////////
// WEBPACK FOOTER
// ./stages/store.js
// module id = 607
// module chunks = 0